/**
 * @jest-environment jsdom
 */

import '../world-map';

describe('d3-world-map element', () => {
  it('Expect <d3-world-map /> element is defined', () => {
    expect(customElements.get('d3-world-map')).toBeDefined();
  });
});
